import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { System } from '../../shared-components/System';
import { DataDefinition, DataDefinitionCategory, DataDefinitionDynamic, DataDefinitionList } from './data-definition.model';
import { CustomizationFrameworkService } from '../../shared-modules/customization-framework/customization-framework.service';
import { YearService } from '../../shared-components/year/year.service';


@Injectable({
  providedIn: 'root'
})
export class DataDefinitionService {

  constructor(
    private http: HttpClient,
    private customizationFrameworkService: CustomizationFrameworkService,
    private yearService: YearService
  ) { }

  getDataDefinitionList(): Observable<DataDefinitionList[]> {
    return this.customizationFrameworkService.getDataDefinitionList(this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID);
  }

  getDataDefinition(enum_value: string, yearId: number, siteYearId: number, masterId: number): Observable<DataDefinition[]> {
    let queryString = '';
      queryString += '?enum_value=' + enum_value +
        '&yearId=' + yearId +
        '&siteYearId=' + siteYearId +
        '&masterId=' + masterId;
    return this.http.get<DataDefinition[]>(System.apiURL.Admin + 'GetDataDefinition' + queryString);
  }

  getDynamicDataDefinition(lookuplistId: number, yearId: number): Observable<DataDefinitionDynamic> {
    let queryString = '';
    queryString += '?lookuplistId=' + lookuplistId +
      '&yearId=' + yearId;
    return this.http.get<DataDefinitionDynamic>(System.apiURL.Admin + 'GetDynamicDataDefinition' + queryString);
  }

  saveDataDefinition(enum_value: string , dataDefRows: DataDefinition[]): Observable<boolean> {
    let queryString = '';
    queryString += '?enum_value=' + enum_value;
    return this.http.post<boolean>(System.apiURL.Admin + 'SaveDataDefinition' + queryString, dataDefRows);
  }

  saveDynamicDataDefinition(tableName: string, keyColName: string, keyColValue: number, dataDef: any): Observable<boolean> {
    let queryString = '';
    queryString += '?tableName=' + tableName +
      '&keyColName=' + keyColName + '&keyColValue=' + keyColValue;
    return this.http.post<boolean>(System.apiURL.Admin + 'SaveDynamicDataDefinition' + queryString, dataDef);
  }

  deleteDataDefinition(id: number): Observable<string> {
    let queryString = '';
    queryString += '?id=' + id;
    return this.http.get<string>(System.apiURL.Admin + 'DeleteDataDefinition' + queryString);
  }

  deleteDynamicDataDefinition(tableName: string, keyColName: string, keyColValue: number): Observable<string> {
    let queryString = '';
    queryString += '?tableName=' + tableName +
      '&keyColName=' + keyColName + '&keyColValue=' + keyColValue;
    return this.http.get<string>(System.apiURL.Admin + 'DeleteDynamicDataDefinition' + queryString);
  }

  getDataDefinitionCategories(): Observable<DataDefinitionCategory[]> {
    return this.http.get<DataDefinitionCategory[]>(System.apiURL.Admin + 'GetDataDefinitionCategories');
  }

  dataDefNameExists(list: DataDefinitionList): Observable<boolean> {
    return this.http.post<boolean>(System.apiURL.Admin + 'DataDefNameExists', list);
  }

  saveDataDefinitionList(list: DataDefinitionList): Observable<DataDefinitionList> {
    return this.http.post<DataDefinitionList>(System.apiURL.Admin + 'SaveDataDefinitionList', list);
  }

  dataDefCodeInUse(dataDefEnum: string, id: number): Observable<boolean> {
    let queryString = '';
    queryString += '?dataDefEnum=' + dataDefEnum + '&id=' + id;
    return this.http.get<boolean>(System.apiURL.Admin + 'IsDataDefinitionCodeInUse' + queryString);
  }

  deleteDataDefinitionList(id: number): Observable<string> {
    let queryString = '';
    queryString += '?id=' + id;
    return this.http.get<string>(System.apiURL.Admin + 'DeleteDataDefinitionList' + queryString);
  }
}
